/* CoHear landing page interactions (Shopify theme version)
   - Scroll-reveal via IntersectionObserver
   - Hero slider crossfade with clickable dots
   - Demo video click-to-play overlay
   - Waitlist form client-side validation; valid submissions post natively
     to Shopify ({% form 'customer' %}), which tags the customer "waitlist"
     and redirects to /pages/thank-you via the form's return_to field.
   - Mobile menu toggle
   All motion collapses to static under prefers-reduced-motion. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    // Stagger siblings that share a parent so grouped items enter in sequence.
    var groups = new Map();
    revealEls.forEach(function (el) {
      var parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, 0);
      var index = groups.get(parent);
      el.style.setProperty('--reveal-delay', Math.min(index * 90, 360) + 'ms');
      groups.set(parent, index + 1);
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Hero slider ---------- */
  // Crossfade through the hero images. Dots are clickable buttons; autoplay
  // pauses on hover/focus and is disabled under prefers-reduced-motion
  // (manual switching still works).
  var slider = document.querySelector('[data-hero-slider]');

  if (slider) {
    var slides = slider.querySelectorAll('img');
    var dots = document.querySelectorAll('.hero-slider-dots button');
    var current = 0;
    var timer = null;

    var goTo = function (index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    };

    var stop = function () {
      if (timer) { clearInterval(timer); timer = null; }
    };

    var start = function () {
      if (reduceMotion || slides.length < 2 || timer) return;
      timer = setInterval(function () { goTo((current + 1) % slides.length); }, 4000);
    };

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        stop();
        goTo(index);
        start();
      });
    });

    var media = slider.closest('.hero-media');
    if (media) {
      media.addEventListener('mouseenter', stop);
      media.addEventListener('mouseleave', start);
      media.addEventListener('focusin', stop);
      media.addEventListener('focusout', start);
    }

    start();
  }

  /* ---------- Demo video ---------- */
  // Click-to-play with sound: the overlay button hands off to the native
  // controls on first play; the overlay returns when the video ends.
  // Without JS the native controls stay on the video and it works as-is.
  var demo = document.querySelector('[data-demo-video]');

  if (demo) {
    var demoVideo = demo.querySelector('video');
    var demoPlay = demo.querySelector('.demo-play');

    demoVideo.removeAttribute('controls');

    demoPlay.addEventListener('click', function () {
      demoVideo.setAttribute('controls', '');
      demoVideo.play();
    });

    demoVideo.addEventListener('play', function () {
      demo.classList.add('is-playing');
    });

    demoVideo.addEventListener('ended', function () {
      demo.classList.remove('is-playing');
    });
  }

  /* ---------- Waitlist forms ---------- */
  // Validate on the client for fast feedback, then let the form post natively.
  // Shopify creates/updates the customer and follows the return_to redirect.
  document.querySelectorAll('[data-waitlist]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var note = form.parentElement.querySelector('[data-form-note]');

    form.addEventListener('submit', function (event) {
      var value = input.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      if (!valid) {
        event.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        note.textContent = 'Please enter a valid email address.';
        note.classList.add('is-error');
        input.focus();
        return;
      }

      input.removeAttribute('aria-invalid');
      note.classList.remove('is-error');
      // Don't disable the submit button here: disabling it inside the submit
      // event cancels the native submission in some browsers, and breaks
      // Shopify's hCaptcha flow, which intercepts and re-submits the form.
      note.textContent = 'Joining...';
      // No preventDefault: native submit proceeds.
    });
  });

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.getElementById('mobile-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden') === false;
      if (open) {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      } else {
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
      }
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();
